
/**
 * Created by Yoyo Fang on 09/10/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentRef, Output, EventEmitter, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';

import { DynamicComponentService } from '../../../services/dynamic-component.service';
import { WidgetInstance } from '../widget-list.model';
import { UUID } from 'angular2-uuid';
import { OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'tam-widget-list-item',
    templateUrl: './widget-list-item.component.html',
    styleUrls: ['./widget-list-item.component.scss']
})
export class WidgetListItemComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    @Input() instance: WidgetInstance;
    // tslint:disable-next-line: no-output-on-prefix
    @Output() onDelete: EventEmitter<any> = new EventEmitter();
    @Output() refresh: EventEmitter<any> = new EventEmitter();
    @ViewChild('container', { static: false, read: ViewContainerRef }) container: ViewContainerRef;
    componentRef: ComponentRef<any>;
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _dynamicComponentService: DynamicComponentService
    ) {
    }

    ngOnInit() {
    }


    ngOnDestroy() {
    }

    ngAfterViewInit(): void {
        this.createComponent(this.instance);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.instance.previousValue && changes.instance.currentValue) {
            this.createComponent(changes.instance.currentValue);
        }
    }
    /**
     * create dynimac component
     */
    createComponent<T>(instance: WidgetInstance): WidgetInstance {
        const componentRef = this._dynamicComponentService.loadComponent<T>(this.container, instance.componentType, true);
        if (!instance.id) {
            instance.id = UUID.UUID();
        }
        instance.componentReference = componentRef;
        instance.componentInitializer(instance);
        this.instance = instance;
        this._changeDetectorRef.detectChanges();
        return instance;
    }

    /**
     * delete a dynimac component
     */
    deleteComponent<T>(): string {
        if (this.instance && this.instance.deletable) {
            this.instance.componentReference.destroy();
            const id = this.instance.id;
            // this.instance = null;
            this.onDelete.emit(id);
            this._changeDetectorRef.detectChanges();
            return id;
        }
        return null;
    }

    refreshItem() {
        this.instance.componentReference.destroy();
        this.refresh.emit(this.instance);
    }
}

